export default {
    plans: {
        form:{
            
        }
    },
}
